import _ from 'lodash';
import { ExperienceType } from '@vizsla/types';
export const getExperienceOptionName = (option, experience) => {
    if (experience.experienceType === ExperienceType.registration) {
        return _.get(option, 'name', '');
    }
    return _.get(option, 'ticketName', '');
};
